import React from "react";
import { MainContainer, TextContainer } from "./styles";
import Typography from "../../../../components/Typography";
import { Column } from "../../../../themes/globalStyle";
import { useNavigate } from "react-router-dom";
import { CardProps } from "./types";
import { Avatar } from "antd";
import ThemeColors from "../../../../themes/colors";

const Card: React.FC<CardProps> = ({ id, title, url, avatar }): JSX.Element => {
  const navigate = useNavigate();

  const handleSelectItem = (id: string) => {
    navigate(`/empresa/${id}`);
  };

  return (
    <MainContainer onClick={() => handleSelectItem(id)}>
      <div style={{ width: 56, height: 56 }}>
        <Avatar
          src={`https://api.dicebear.com/9.x/shapes/svg?seed=${parseFloat(
            avatar
          )}`}
          size={56}
          style={{ background: ThemeColors.Purple100 }}
        />
      </div>
      <Column gap="0.2rem" style={{overflow: "hidden"}}>
        <TextContainer title={title}>
          <Typography text={title} size="large" color="Black500" weight={500} />
        </TextContainer>
        <TextContainer title={url}>
          <Typography text={url} size="small" color="Black100" weight={400} />
        </TextContainer>
      </Column>
    </MainContainer>
  );
};

export default Card;
